import { ActivityMenuPair } from "components/selection-components/summary/activity-menu-pair";
import { getSummaryResourcePaymentBreakdownText } from "utils/payment-utils";

/**
 * Calculates the total visible price for an activity (resource price + menu price)
 */
export function getActivityVisiblePrice(activity: ActivityMenuPair): number {
    return activity.resourceTotalPrice + activity.menuPrice;
}

/**
 * Determines if an activity price should be displayed based on its value
 */
export function shouldShowActivityPrice(activity: ActivityMenuPair): boolean {
    return getActivityVisiblePrice(activity) > 0;
}

/**
 * Gets the formatted price text for an activity, or null if price shouldn't be shown
 */
export function getActivityPriceText(activity: ActivityMenuPair, guests: number): string | null {
    if (!shouldShowActivityPrice(activity)) return null;
    return getSummaryResourcePaymentBreakdownText(activity, guests) ?? null;
}
